import { em } from 'polished'
import styled, { css } from 'styled-components'

import { GOODS_TYPES } from 'constants/sales'

const { wgs, dna } = GOODS_TYPES

export const Bar = styled.div`
  height: 100%;
  border-top-right-radius: ${p => p.theme.blocks.blockBorderRadiusLarge};
  border-bottom-right-radius: ${p => p.theme.blocks.blockBorderRadiusLarge};

  ${p => p.theme.mq.upMd} {
    width: 0;
    transition: width 900ms ease-out;

    ${({ isAnimationActive }) =>
      isAnimationActive &&
      css`
        width: 100%;
      `}
  }

  ${p => p.theme.mq.upLg} {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top-right-radius: ${p => p.theme.blocks.blockBorderRadiusLarge};
    border-top-left-radius: ${p => p.theme.blocks.blockBorderRadiusLarge};
    border-bottom-right-radius: 0;
    height: 0;
  }
`
export const WForeverBoxWrapper = styled.div`
  position: absolute;
  height: ${em(77)};
  opacity: 1;

  ${p => p.theme.mq.upMd} {
    opacity: 0;
    transform: translateY(${em(10)});
    transition-property: opacity, transform;
    transition-duration: 600ms;
    transition-delay: 300ms;
    transition-timing-function: ease-out;

    ${({ isAnimationActive }) =>
      isAnimationActive &&
      css`
        opacity: 1;
        transform: translateY(0);
      `}
  }

  ${p => p.theme.mq.upLg} {
    position: absolute;
    width: ${em(115)};
    height: ${em(77)};
    opacity: 0;
    transform: translateY(${em(30)});
  }
`

export const BarWrapper = styled.div`
  position: absolute;
  height: ${em(20)};

  ${p => p.theme.mq.upLg} {
    height: auto;
  }

  ${({ productType }) =>
    productType === wgs &&
    css`
      width: ${em(300)};
      top: ${em(75)};

      ${p => p.theme.mq.upMd} {
        width: ${em(493)};
        top: ${em(160)};
      }

      ${p => p.theme.mq.upLg} {
        width: ${em(30)};
        height: ${em(519)};
        bottom: 0;
        top: auto;
      }

      ${WForeverBoxWrapper} {
        left: ${em(5)};
        top: ${em(35)};
        width: calc(100vw - ${em(25)});

        ${p => p.theme.mq.upMd} {
          left: ${em(520)};
          top: -${em(25)};
          width: calc(100vw - ${em(540)});
        }

        ${p => p.theme.mq.upLg} {
          left: ${em(75)};
          top: -${em(15)};
          width: ${em(370)};
        }
      }

      ${Bar} {
        background: linear-gradient(270deg, #7349ff 0%, #4c32a0 99.09%);

        ${p => p.theme.mq.upLg} {
          background: linear-gradient(180deg, #7349ff 0%, #4c32a0 99.09%);
        }
      }
    `}

  ${({ productType }) =>
    productType === dna &&
    css`
      width: ${em(88)};
      top: -${em(5)};

      ${p => p.theme.mq.upMd} {
        width: ${em(111)};
      }

      ${p => p.theme.mq.upLg} {
        width: ${em(30)};
        height: ${em(80)};
        left: ${em(90)};
        bottom: 0;
        top: auto;
      }

      ${WForeverBoxWrapper} {
        width: calc(100vw - ${em(35)});
        left: ${em(15)};
        top: -${em(70)};

        ${p => p.theme.mq.upMd} {
          width: ${em(420)};
          left: ${em(140)};
          top: -${em(18)};
        }

        ${p => p.theme.mq.upLg} {
          left: -${em(5)};
          top: -${em(98)};
          width: ${em(440)};
        }
      }

      ${Bar} {
        background: linear-gradient(270deg, #ffb633 0.82%, #ffa845 100%);

        ${p => p.theme.mq.upLg} {
          background: linear-gradient(180deg, #ffb633 0.82%, #ffa845 100%);
        }
      }
    `}
`
